export enum FreezeStatus {
    N = "N",
    S = "S",
    H = "H",
}
